"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSplitterContractDeployButton = exports.PAYMENT_SPLITTER_CONTRACT_DEPLOY_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const deployPaymentSplitter_json_1 = __importDefault(require("@framework/abis/json/PaymentSplitterFactoryFacet/deployPaymentSplitter.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const dialog_1 = require("./dialog");
exports.PAYMENT_SPLITTER_CONTRACT_DEPLOY_DIALOG_KEY = "paymentSplitterContractDeploy";
const PaymentSplitterContractDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const handleDeploy = () => {
        openFormDialog(exports.PAYMENT_SPLITTER_CONTRACT_DEPLOY_DIALOG_KEY, void 0, "button");
    };
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployPaymentSplitter_json_1.default,
            functionName: "deployPaymentSplitter",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                {
                    payees: values.payees,
                    shares: values.shares.map(s => BigInt(s)),
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/payment-splitter",
            method: "POST",
            data,
        }, form);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "PaymentSplitterContractDeployButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.PaymentSplitterContractDeployDialog, { onExternalConfirm: onDeployConfirm, open: formDialogUniqueKey === `${exports.PAYMENT_SPLITTER_CONTRACT_DEPLOY_DIALOG_KEY}.${mode}` })] }));
};
exports.PaymentSplitterContractDeployButton = PaymentSplitterContractDeployButton;
//# sourceMappingURL=index.js.map